module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }